export const FIELD_COLUMN_WIDTH = 420;
export const DRAG_COLUMN_WIDTH = 40;
export const ACTION_COLUMN_WIDTH = 70;
export const TOGGLE_BUTTON_COLUMN_WIDTH = 90;
